/** Personal learner routes are not permissions to browse or edit the library. */
export function isPersonalContentRoute(pathname: string): boolean {
  return /^\/user\/my-content\/?$/.test(pathname)
    || /^\/user\/content\/(?!new(?:\/|$))[^/]+(?:\/take)?\/?$/.test(pathname)
}

export const learnerContentPath = '/user/my-content'

/** One learner entry; a catalogue grant is not required for personal assignments. */
export function learnerExplorePath(grants: readonly string[] = []): string {
  return grants.some(grant => grant === 'explore' || grant === 'library')
    ? '/user/explore/content'
    : learnerContentPath
}
